import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SortDownArrow } from "../../../../assets/svg";
import Action from "../../../../components/common/Action";
import {
  Badge,
  DefaultPrimaryButton,
} from "../../../../components/micro/input";
import DebounceSearch from "../../../../components/common/DebounceSearch";
import RippleLoader from "../../../../components/loader/RippleLoader";
import CustomTable from "../../../../components/customTable/CustomTable";
import ConfirmationModel from "../../../../components/common/ConfirmationModel";
import ReactSelect from "react-select";
import {
  DeleteStaff,
  companiesStaff,
  getCompanies,
  getOutlet,
  updateStaff,
} from "../../../../redux/companies/slice";
import { useDispatch, useSelector } from "react-redux";
import AddEditTransfer from "../../modal/AddEditTransfer";
import Toggles from "../../../../components/common/Toggles";

const Staff = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const storedData = sessionStorage.getItem("companyData");
  const companyData = storedData ? JSON.parse(storedData)?.company : null;
  const [searchValue, setSearchValue] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [isLoading, setIsLoading] = useState(false);
  const [equipmentDelete, setEquipmentDelete] = useState(null);
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [isPreferredOpen, setIsPreferredOpen] = useState(false);
  const [transferData, setTransferData] = useState(null);
  const [mode, setMode] = useState("");

  // Selector
  const { staffList, outletList, loading } = useSelector((store) => ({
    staffList: store?.companiesData?.companiesStaffStatus?.data?.data,
    outletList: store?.companiesData?.getOutletStatus?.data,
    loading: store?.companiesData?.loading,
  }));

  useEffect(() => {
    dispatch(
      companiesStaff({
        search: searchValue,
        roles: selectedRole?.value || "",
        pageCount: pageCount,
        pageLimit: pageLimit,
        types: selectedType?.value || "",
        outlet: selectedOutlet?.label || "",
        company_id: companyData?.id || "",
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
      })
    );
    dispatch(
      getOutlet({
        search: "",
        pageCount: "",
        pageLimit: "all",
        company_id: companyData?.id || "",
        sort_by: '',
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
      })
    );
  }, [
    selectedRole,
    pageCount,
    pageLimit,
    selectedType,
    selectedOutlet,
    searchValue,
    sortBy,
    sortDirection,
  ]);

  const deleteStaff = () => {
    setIsLoading(true);
    dispatch(DeleteStaff(equipmentDelete))
      .then((res) => {
        if (res.type === "DeleteStaff/fulfilled") {
          dispatch(
            companiesStaff({
              search: searchValue,
              roles: selectedRole?.value || "",
              pageCount: pageCount,
              pageLimit: pageLimit,
              types: selectedType?.value || "",
              outlet: selectedOutlet?.label || "",
              company_id: companyData?.id || "",
              sort_by: sortBy,
              sort_direction: sortDirection === "asc" ? "asc" : "desc",
            })
          );
        }
        setConfirmDelete(false);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error deleting remark:", error);
        setIsLoading(false);
        setConfirmDelete(false);
      });
  };

  const handleOutletChange = (selectedOption) => {
    setSelectedOutlet(selectedOption);
  };

  const handleTypeChange = (selectedOption) => {
    setSelectedType(selectedOption);
  };

  const handleRoleChange = (selectedOption) => {
    setSelectedRole(selectedOption);
  };

  const handleTransfer = ({ transfer, mode }) => {
    setMode(mode);
    setTransferData(transfer);
    setIsPreferredOpen(true);
  };

  const closeModal = () => {
    setIsPreferredOpen(false);
  };

  const updateStatus = (item, status, isActive) => {
    dispatch(
      updateStaff({
        id: item?.id,
        data: {
          status: status,
          is_active: isActive,
        },
      })
    ).then((res) => {
      if (res.type === "updateStaff/fulfilled") {
        dispatch(
          companiesStaff({
            search: searchValue,
            roles: selectedRole?.value || "",
            pageCount: pageCount,
            pageLimit: pageLimit,
            types: selectedType?.value || "",
            outlet: selectedOutlet?.label || "",
            company_id: companyData?.id || "",
            sort_by: sortBy,
            sort_direction: sortDirection === "asc" ? "asc" : "desc",
          })
        );
      }
    });
  };

  const handleToggle = (item) => {
    const newStatus = item.status === "active" ? "inactive" : "active";
    const isActive = newStatus === "active";

    updateStatus(item, newStatus, isActive);
  };

  // Table Headers
  const ColumnHeaders = () => (
    <>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        No.
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        <div
          className="flex items-center cursor-pointer"
          onClick={() => {
            setSortBy("name");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Name</span>
          <SortDownArrow
            className={`ml-1 transition-transform ${
              sortDirection === "asc" && sortBy === "name" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Mobile
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        <div
          className="flex items-center cursor-pointer"
          onClick={() => {
            setSortBy("type");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Type</span>
          <SortDownArrow
            className={`ml-1 transition-transform ${
              sortDirection === "asc" && sortBy === "type" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        <div
          className="flex items-center cursor-pointer"
          onClick={() => {
            setSortBy("role");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Role</span>
          <SortDownArrow
            className={`ml-1 transition-transform ${
              sortDirection === "asc" && sortBy === "role" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Outlet Name
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Status
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Actions
      </th>
    </>
  );

  // Table Rows
  const DataRows = () => (
    <>
      {(staffList?.data || []).map((item, index) => (
        <tr
          key={item.id}
          className="text-gray-500 shadow-sm text-mgrey hover:bg-lightprimaryorange"
        >
          <td className="px-5 py-3">{index + 1}</td>
          <td className="px-5 py-3">{item?.user?.full_name || "-"}</td>
          <td className="px-5 py-3">{item?.user?.phone || "-"}</td>
          <td className="px-5 py-3">
            <div className="flex justify-start ">
              <Badge
                className={`capitalize whitespace-nowrap ${
                  item?.outlet_type === "Outlet"
                    ? "text-themeBtn "
                    : item?.outlet_type === "HQ"
                    ? "border-grey text-primaryBlack"
                    : ""
                }`}
                value={
                  item?.outlet_type === "Outlet"
                    ? "Outlet"
                    : item?.outlet_type === "HQ"
                    ? "HQ"
                    : "" || "-"
                }
              />
            </div>
          </td>
          <td className="px-5 py-3">
            <div className="flex justify-start ">
              <Badge
                className={`capitalize whitespace-nowrap ${
                  item?.user?.role === "staff"
                    ? "text-themeBtn "
                    : item?.user?.role === "manager"
                    ? "border-lightBlue text-chipBlue"
                    : item?.user?.role === "finance"
                    ? "border-grey text-primaryBlack"
                    : item?.user?.role === "operation"
                    ? "border-grey text-primaryBlack"
                    : ""
                }`}
                value={
                  item?.user?.role === "staff"
                    ? "Staff"
                    : item?.user?.role === "manager"
                    ? "manager"
                    : item?.user?.role === "finance"
                    ? "finance"
                    : item?.user?.role === "operation"
                    ? "operation"
                    : "" || "-"
                }
              />
            </div>
          </td>
          <td className="px-5 py-3">
            {item?.outlets?.map((outletItem, index) => (
              <span key={outletItem?.id}>
                {outletItem?.outlet?.name || "-"}
                {index < item.outlets.length - 1 && ", "}
              </span>
            ))}
          </td>

          <td className="px-4 py-3 truncate">
            <Toggles
              checked={item?.status === "active"}
              toggleFor={item?.id}
              onChange={() => handleToggle(item)}
            />
          </td>
          <td className="flex px-5 py-3">
            <Action
              optionList={
                <>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() =>
                      navigate("/create-edit-staff", {
                        state: { staff: item, mode: "edit" },
                      })
                    }
                  >
                    View/Edit
                  </li>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() => {
                      handleTransfer({ transfer: item, mode: "Staff" });
                    }}
                  >
                    Transfer
                  </li>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() => {
                      setConfirmDelete(true);
                      setEquipmentDelete(item?.id);
                    }}
                  >
                    Delete
                  </li>
                </>
              }
            />
          </td>
        </tr>
      ))}
    </>
  );

  const handleStaffExportClick = () => {
    if (!staffList?.data || staffList?.data.length === 0) {
      alert("No data available to export!");
      return;
    }

    const header = ["Name", "Mobile", "Type", "Role", "Outlet Name", "Status"];

    const rows = staffList?.data.map((staff) => [
      `"${staff?.user?.full_name || "-"}"`,
      `"${staff?.user?.phone || "-"}"`,
      `"${staff?.outlet_type || "-"}"`,
      `"${staff?.user?.role || "-"}"`,
      `"${staff?.outlet?.name || "-"}"`,
      `"${staff?.status || "-"}"`,
    ]);

    let csvContent = header.join(",") + "\n";
    rows.forEach((row) => {
      csvContent += row.join(",") + "\n";
    });

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "staffs_export.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <>
      <div className="space-y-5  w-full bg-white shadow rounded-lg p-4">
        {/* Search and Export Section */}
        <div className="flex items-center space-x-3">
          <ReactSelect
            className={"w-full max-w-52 text-black p-0"}
            id="outlet"
            placeholder="Outlet Name"
            options={(Array.isArray(outletList?.data)
              ? outletList?.data
              : outletList?.data?.data || []
            ).map((outlet) => ({
              value: outlet.id,
              label: outlet.name,
            }))}
            isClearable={true}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            value={selectedOutlet}
            onChange={handleOutletChange}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: selectedOutlet ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "&:active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <ReactSelect
            className={"w-full max-w-52 text-black p-0"}
            id="type"
            placeholder="Types"
            options={[
              {
                value: "Outlet",
                label: "Outlet",
              },
              {
                value: "hq",
                label: "HQ",
              },
            ]}
            isClearable={true}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            value={selectedType}
            onChange={handleTypeChange}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: selectedType ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "&:active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <ReactSelect
            className={"w-full max-w-52 text-black p-0"}
            id="role"
            placeholder="Roles"
            options={[
              {
                value: "staff",
                label: "Staff",
              },
              {
                value: "manager",
                label: "Manager",
              },
              {
                value: "finance",
                label: "Finance",
              },
              {
                value: "operation",
                label: "Operation",
              },
            ]}
            isClearable={true}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            value={selectedRole}
            onChange={handleRoleChange}
            styles={{
              control: (base) => ({
                ...base,
                border: `1px solid #0000003B`,
                borderColor: selectedRole ? "#F15B29" : "#0000003B",
                borderRadius: "0.3rem",
                boxShadow: "none",
                "&:hover": {
                  border: "1px solid #0000003B",
                },
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? "#F15B29" : "white",
                "&:active": {
                  backgroundColor: state.isSelected
                    ? "#F15B29"
                    : "rgba(0, 0, 0, 0.04)",
                },
              }),
            }}
          />
          <DebounceSearch
            className="full-width"
            search={searchValue}
            handleChange={setSearchValue}
            placeholder={"Search..."}
          />
          <DefaultPrimaryButton
            value="EXPORT"
            onClick={handleStaffExportClick}
          />
        </div>

        {/* Loading or Table */}
        {loading ? (
          <RippleLoader />
        ) : (
          <div className="">
            <CustomTable
              columnHeaders={<ColumnHeaders />}
              dataRows={<DataRows />}
              overflowVisibleLg={true}
              data={staffList}
              showPagination
              setPaginationCurrentLimit={setPageLimit}
              paginationCurrentLimit={pageLimit}
              total={staffList?.total}
              current={pageCount}
              lastPage={Math.ceil(staffList?.total / pageLimit)}
              paginationData={(crPage) => setPageCount(crPage)}
            />
          </div>
        )}
      </div>

      {/* Delete Confirmation Modal */}
      {confirmDelete && (
        <ConfirmationModel
          confirmText="Delete"
          onClose={() => setConfirmDelete(false)}
          onConfirm={deleteStaff}
          isLoading={isLoading}
        />
      )}
      {isPreferredOpen && (
        <div>
          <AddEditTransfer
            onClose={closeModal}
            companyId={companyData?.id}
            transferData={transferData}
            mode={mode}
          />
        </div>
      )}
    </>
  );
};

export default Staff;
